// ======================================================================
// Firebase 初始化配置
// 把下面的值换成你自己的:
// Firebase 控制台 -> 项目设置(齿轮图标) -> 常规 -> 往下滑到"你的应用"
// ======================================================================
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDLzgbczYwkoaVzwF1mnv5fVmvCu1sDTXc",
  authDomain: "solarsavings-us-dbab5.firebaseapp.com",
  projectId: "solarsavings-us-dbab5",
  storageBucket: "solarsavings-us-dbab5.firebasestorage.app",
  messagingSenderId: "90099117578",
  appId: "1:90099117578:web:d299748bec0f1e73d079f3"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
